export default function StatsSection() {
  const stats = [
    { value: '50,000+', label: '夜行者', icon: 'ri-user-star-line' },
    { value: '200+', label: '原创文章', icon: 'ri-article-line' },
    { value: '30+', label: '覆盖城市', icon: 'ri-map-pin-line' },
    { value: '98%', label: '好评率', icon: 'ri-heart-line' },
  ];

  return (
    <section className="py-14 bg-background-950 border-t border-b border-background-800/50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-500/10">
                <i className={`${stat.icon} text-primary-400 text-lg`}></i>
              </div>
              <div className="font-heading text-2xl md:text-3xl text-foreground-100 mb-1">{stat.value}</div>
              <div className="text-foreground-500 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}